export const SESSION_SHOW_TABS = ['general'] as const;

export type SessionShowTab = (typeof SESSION_SHOW_TABS)[number];

export const SESSION_DEFAULT_TAB: SessionShowTab = 'general';
